import { useEffect, useState, useCallback } from "react";
import { deleteLoanOfficer, addLoanOfficer, updateLoanOfficer, getAllLoanOfficer } from '../LoanOfficerService'

export default function useLoanOfficer() {
    const [shouldOpenEditorDialog, setShouldOpenEditorDialog] = useState(false);
    const [LoanOfficer, setLoanOfficer] = useState(null);
    const [shouldOpenConfirmationDialog, setShouldOpenConfirmationDialog] = useState(false);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const handleChangePage = (_, newPage) => setPage(newPage);
    const [LoanOfficers, setLoanOfficers] = useState([]);

    useEffect(() => {
        updatePageData();
    }, []);

    const handleEditUser = (LoanOfficer) => async (event) => {
        setLoanOfficer(LoanOfficer);
        setShouldOpenEditorDialog(true);
    };

    const updatePageData = () => {
        getAllLoanOfficer().then(response => {
            setLoanOfficers(response.data.loanOfficers);
        }).catch(error => {
            console.error('Failed to fetch List Type data', error);
        });
    };

    const handleSave = async (LoanOfficer, isNew, setFieldError) => {
        let apiPayload;
        if (isNew) {
            apiPayload = {
                Code: parseInt(LoanOfficer.Code),
                Description: LoanOfficer.Description
            };
            console.log("apiPayload", apiPayload);
            const response = await addLoanOfficer(apiPayload);
            if (response.data.success) {
                setShowSuccessAlert(true);
                setTimeout(() => setShowSuccessAlert(false), 3000);
                handleDialogClose();
                setTimeout(updatePageData, 500);
            } else {
                //alert('Failed to save Loan Type.');
                setFieldError('Code', response.data.errorMessage);
                return response.data.errorMessage;
            }
        } else {
            apiPayload = {
                Id: LoanOfficer.ID,
                Code: LoanOfficer.Code,
                Description: LoanOfficer.Description,
                StatusLUId: LoanOfficer.StatusLUId
            };

            const response = await updateLoanOfficer(apiPayload);
            if (response.data.success) {
                handleDialogClose();
                setTimeout(updatePageData, 500);
            } else {
                setFieldError('Code', response.data.errorMessage);
                return response.data.errorMessage;
            }
        }
    };

    const handleDialogClose = () => {
        setShouldOpenEditorDialog(false);
        setShouldOpenConfirmationDialog(false);
        updatePageData();
    };

    const handleConfirmationResponse = () => {
        if (LoanOfficer) {
            deleteLoanOfficer(LoanOfficer.id).then(response => {
                if (response.data.success) {
                    setShowSuccessAlert(true);
                    setTimeout(() => setShowSuccessAlert(false), 3000);
                    handleDialogClose();
                    setTimeout(updatePageData, 500);
                } else {
                    alert('Failed to delete Loan Type.');
                }
            }).catch(error => {
                console.error('Error deleting Loan Type', error);
                alert('Failed to delete Loan Type.');
            });
        }
    };

    const handleDeleteUser = (user) => {
        setLoanOfficer(user);
        setShouldOpenConfirmationDialog(true);
    };

    return {
        setLoanOfficer,
        setShouldOpenEditorDialog,
        handleEditUser,
        handleDeleteUser,
        shouldOpenEditorDialog,
        page,
        rowsPerPage,
        setRowsPerPage,
        LoanOfficer,
        handleDialogClose,
        handleSave,
        LoanOfficers,
        shouldOpenConfirmationDialog,
        handleConfirmationResponse,
        handleChangePage,
        updatePageData
    }
}